export default __webpack_public_path__ + "static/media/logo.1a76c975.svg";